import React, { useState } from 'react';
import { Card, Button, Input, Space, Typography, Divider } from 'antd';
import { getLeadDetails, searchAndGetLeadDetails } from '../examples/LeadUsageExample';

const { Text, Title } = Typography;

export default function LeadTestComponent() {
  const [leadId, setLeadId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const testGetLeadById = async () => {
    if (!companyId || !leadId) {
      alert('Please enter Company ID and Lead ID');
      return;
    }

    setLoading(true);
    try {
      const leadDetails = await getLeadDetails(companyId, leadId);
      setResult({
        type: 'single',
        data: leadDetails
      });
      console.log('Lead Details:', leadDetails);
    } catch (error) {
      console.error('Error:', error);
      setResult({
        type: 'error',
        data: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  const testSearchByPhone = async () => {
    if (!companyId || !phoneNumber) {
      alert('Please enter Company ID and Phone Number');
      return;
    }

    setLoading(true);
    try {
      const searchResult = await searchAndGetLeadDetails(companyId, phoneNumber);
      setResult({
        type: 'search',
        data: searchResult
      });
      console.log('Search Result:', searchResult);
    } catch (error) {
      console.error('Error:', error);
      setResult({
        type: 'error',
        data: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  const renderSingleLead = (lead) => (
    <div style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '10px' }}>
      <div><Text strong>Lead ID:</Text> {lead.leadId}</div>
      <div><Text strong>Name:</Text> {lead.name}</div>
      <div><Text strong>Email:</Text> {lead.email}</div>
      <div><Text strong>Phone:</Text> {lead.phone}</div>
      <div><Text strong>Project Name:</Text> {lead.projectName}</div>
      <div><Text strong>Assigned User:</Text> {lead.assignedUser.name}</div>
      <div><Text strong>Manager Email:</Text> {lead.assignedUser.email}</div>
      <div><Text strong>Created Date:</Text> {lead.createdDate}</div>
      <div><Text strong>Status:</Text> {lead.status}</div>
      <div><Text strong>Source:</Text> {lead.source}</div>
    </div>
  );

  return (
    <Card title="Lead API Test Component" style={{ margin: '20px 0' }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <div>
          <Text strong>Company ID:</Text>
          <Input
            placeholder="Enter Company ID"
            value={companyId}
            onChange={(e) => setCompanyId(e.target.value)}
            style={{ marginLeft: '10px', width: '200px' }}
          />
        </div>

        <Divider />

        <Title level={5}>Test 1: Get Lead by ID</Title>
        <Space>
          <Input
            placeholder="Enter Lead ID"
            value={leadId}
            onChange={(e) => setLeadId(e.target.value)}
            style={{ width: '200px' }}
          />
          <Button onClick={testGetLeadById} loading={loading} type="primary">
            Get Lead Details
          </Button>
        </Space>

        <Divider />

        <Title level={5}>Test 2: Search by Phone Number</Title>
        <Space>
          <Input
            placeholder="Enter Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            style={{ width: '200px' }}
          />
          <Button onClick={testSearchByPhone} loading={loading} type="primary">
            Search by Phone
          </Button>
        </Space>

        <Divider />

        {result && (
          <div>
            <Title level={5}>Result:</Title>
            {result.type === 'error' && (
              <div style={{ color: 'red' }}>Error: {result.data}</div>
            )}
            
            {result.type === 'single' && (
              <div>
                <Text strong>Single Lead Found:</Text>
                {renderSingleLead(result.data)}
              </div>
            )}
            
            {result.type === 'search' && (
              <div>
                {result.data.found ? (
                  <div>
                    <Text strong>Found {result.data.count} leads:</Text>
                    {result.data.leads.map((lead, index) => (
                      <div key={index}>
                        <Text strong>Lead {index + 1}:</Text>
                        {renderSingleLead(lead)}
                      </div>
                    ))}
                  </div>
                ) : (
                  <Text>No leads found with this phone number</Text>
                )}
              </div>
            )}
          </div>
        )}
      </Space>
    </Card>
  );
}